import { useBuildex } from '@/hooks/use-buildex/index';
import { features as featureConstant } from '@/utils/feature-verifier';

const redirectGuard = (meta) => meta.dispatch(redirectGuardAction(meta));

const redirectGuardAction = (to) => (_dispatch, getState) => {

	const state = getState();

	if (state.auth.loggedIn) {

		const isBuildex = useBuildex();
		const features = state.auth.features;
		const dashboard  = state?.auth?.profile?.dashboard
		const isSupersetDashboard = Array.isArray(features) && features.includes(featureConstant.DASHBOARD);
		const isEmbedDashboard = Array.isArray(features) && features.includes(featureConstant.DASHBOARD_EMBEDDING)
		if(isEmbedDashboard){
			return isBuildex && isSupersetDashboard && dashboard?.length>0? `/dashboard/${dashboard[0].id}` :`/shared-data`
		}
		return isBuildex && isSupersetDashboard ? '/dashboard' : '/shared-data';
	}

	return null
}

export { redirectGuard };

